export const ROLE_TYPE_REQUEST = 'ROLE_TYPE_REQUEST';
export const ROLE_TYPE_SUCCESS = 'ROLE_TYPE_SUCCESS';
export const ROLE_TYPE_FAIL = 'ROLE_TYPE_FAIL';

